export const HOST = [location.protocol, location.host].join("//");
